import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import BellNotifiaction from '../BellNotifiaction'
import PostsOfProcessedProducts from '../PostofProcessed Food';

export default function ProcessedFoodProduct() {
    const [fname11, setfname11] = useState("");
    const [ProcessedProductDescriptio,setProcessedProductDescriptio] = useState("");
    const [newFile11, setNewFile11] = useState(null);
    const [newdata11, setnewData11] = useState([]);
  
  
  
    const setData11 = (e) => {
      const { value } = e.target;
      setfname11(value);
    };
    const setData15 = (e) => {
      const { value } = e.target;
      setProcessedProductDescriptio(value);
    };
    const setimgfile = (e) => {
      setNewFile11(e.target.files[0]);
    };
  
    // Add image
  
    const addUserData11 = async (e) => {
      
      var formData11 = new FormData();
      console.log(newFile11);
      var filename = newFile11.name;
      formData11.append("photo11", newFile11, filename);
      formData11.append("fname11", fname11);
      formData11.append("ProcessedProductDescriptio", ProcessedProductDescriptio);
      console.log(formData11);
  
      const config = {
        headers: {
          "Content-Type": " multipart/form-data",
        },
      };
  
      const res = await axios.post(
        "https://pratik-agro-backend.vercel.app/AddProcessedFoodProductimg",
        formData11,
        config
      );
  
      console.log(res);
    };
    //get image
  
    const detuserData11 = async () => {
      const res11 = await axios.get("https://pratik-agro-backend.vercel.app/getProcessedFoodproductimg", {
        headers: {
          "Content-Type": " application/json",
        },
      });
      if (res11.data.status === 401 || !res11.data) {
        console.log("error");
      } else {
        setnewData11(res11.data.getImage.reverse());
      }
    };
    useEffect(() => {
      detuserData11();
    }, []);
   
  //delete data
  const deleteimage = async (id) => {
   
    const res6 = await fetch(`https://pratik-agro-backend.vercel.app/deletedata11/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const deleteStud = await res6.json();
    console.log(deleteStud);
    if (res6.status === 422 || !deleteStud) {
      console.log("error");
    } else {
      detuserData11();
    }
  
  };
  return (
    <div className='content'>
    <div className="mt-2 mb-1 d-flex justify-content-between align-items-center">
        <i>
          <h2>Product Images </h2>
        </i>
       <div>
     
       <BellNotifiaction />
       <Link
          type="button"
          to="/Addhomeimage"
          className="btn btn-light shadow addimage "
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          Add Image
        </Link>
       </div>
        
        
      </div>
      <div className=" container text-end mt-5">
        {/* <Link  to="/Addhomeimage"className="btn btn-success "> Add Data</Link> */}
        
        <div
          class="modal fade "
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog ">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="staticBackdropLabel">
                Product Image
                </h1>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <form>
                  <div>
                    
                      <p style={{float:'left'}}> Product Name:-</p>
                    
                    <input
                      type="text"
                      name="fname11"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                       onChange={setData11}
                    />

                      <p style={{float:'left'}}> Description:-</p>
                    
                    <input
                      type="text"
                      name="ProcessedProductDescriptio"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                       onChange={setData15}
                    />

                    <div>
                      <p style={{float:'left'}}>Add Your Image:-</p>
                    </div>
                    <input
                      type="file"
                      name="photo11"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                       onChange={setimgfile}
                    />
                    <button
                      type="submit"
                      className="btn btn-primary mt-5"
                       onClick={addUserData11}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
        
        
       
            <PostsOfProcessedProducts posts={newdata11} deleteimage={deleteimage}/>
        
      
      
    </div>
  )
}
